var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"read-member-history-file"},[_vm._v(" reading ")])
}
var staticRenderFns = []

export { render, staticRenderFns }